import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles, Chip } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FormControl from '@material-ui/core/FormControl';
import Modal from '@material-ui/core/Modal';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Alert from '@material-ui/lab/Alert';

import isEmpty from 'lodash/isEmpty';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ADGMModal, ADGMImage } from 'aurora-components';
import messages from 'aurora-translations';
import { getPropertType, keyEmptyCheck } from 'aurora-utils/utils';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import stylesHeader from './stylesHeader';

function ApprovalHeader(props) {
  const {
    classes,
    handleSubmit,
    handleRejectSubmit,
    rejectWithFeedback,
    property,
    failure,
    state,
    submitApplicationReject,
    locale,
    applicationType,
    applicationNumber,
    showPrimaryButton,
    primaryBtnLabel,
    SecondaryBtnLabel,
    showRejectApplicationBtn = false,
    // showSecondaryBtnIcon = false,
    showSecondaryButton = true,
    showApplicationHeader = false,
    rejectionTitle,
    rejectionPlaceHolder,
    handleCancelApplication,
    intl,
    helperTextValue,
  } = props;

  const [isModalOpenAcceptCancel, setModalOpenAcceptCancel] = useState(false);
  const [isModalOpenReject, setModalOpenReject] = useState(false);
  const [isModalOpenApplicationReject, setModalOpenApplicationReject] = useState(false);
  const [isModalOpenReturnAndReject, setModalOpenReturnAndReject] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [isModalOpenCancellation, setModalOpenCancellation] = useState(false);
  const [isRejectWithFeedBack, setIsRejectWithFeedback] = useState(false);

  const [isDownloadMenuOpen, setDownloadMenuOpen] = useState(null);

  const handleClose = () => {
    setDownloadMenuOpen(null);
  };

  const toggleModalCancellation = () => {
    setModalOpenCancellation(!isModalOpenCancellation);
  };
  const toggleModalAcceptCancel = () => {
    setModalOpenAcceptCancel(!isModalOpenAcceptCancel);
  };
  const toggleModalReject = () => {
    setModalOpenReject(!isModalOpenReject);
  };

  const toggleModalRejectWithFeedback = () => {
    setInputVal('');
    setIsRejectWithFeedback(!isRejectWithFeedBack);
  };

  const toggleModalApplicationReject = () => {
    setModalOpenApplicationReject(!isModalOpenApplicationReject);
  };
  const returnAndRejectmodal = () => {
    setModalOpenReturnAndReject(!isModalOpenReturnAndReject);
  };

  const submitRejection = () => {
    toggleModalReject();
    const req = {
      rejection: inputVal,
      approval: false,
    };
    handleSubmit(req);
  };

  const submitRejectionWithfeedback = () => {
    toggleModalRejectWithFeedback();
    const req = {
      rejection: inputVal,
      approval: false,
    };
    handleRejectSubmit(req);
  };

  const inputHandler = event => {
    setInputVal(event.target.value);
  };

  const submitHandler = () => {
    const req = {
      rejection: '',
      approval: true,
    };
    handleSubmit(req);
  };

  return (
    <>
      {failure?.statusCode && (
        <Alert severity='error' className={classes.errorMessage}>
          {keyEmptyCheck(failure?.message)}
        </Alert>
      )}

      <Grid container spacing={2} alignItems='center' className={classes.initiateserviceSect}>
        {!showApplicationHeader && (
          <Grid item xs={12} md={6} className={classes.initiateservicedtaile}>
            <ADGMImage alt='Image2' name='offPlan1x.svg' />
            <div className={classes.textHolder}>
              <Typography variant='h6' component='h1' className={classes.Title}>
                <FormattedMessage {...messages.plot_number} />:{property?.plotNumber}
                <Chip
                  label={keyEmptyCheck(getPropertType(property?.propertyType))}
                  className={classNames(classes.darkgreen, classes.initibadges)}
                />
              </Typography>
              <Typography variant='body1' className={classes.subTitle}>
                {locale === 'en'
                  ? property?.districtEn + ',' + property?.communityEn
                  : property?.districtAr + ', ' + property?.communityAr}
                {!isEmpty(property?.mortgagesUpdated) && (
                  <Chip
                    label={keyEmptyCheck('mortgaged')}
                    className={classNames(classes.initibadges, classes.warning)}
                  />
                )}
              </Typography>
            </div>
          </Grid>
        )}
        {showApplicationHeader && (
          <Grid item xs={12} md={6} className={classes.headerV2}>
            {![
              'PMA_REGISTRATION',
              'PMA_RENEWAL',
              'PMA_CANCELLATION',
              'PMA_AMENDMENT',
              'MORTGAGE_REGISTRATION_LAND',
              'MORTGAGE_REGISTRATION_UNIT',
            ].includes(applicationType) && (
              <Box>
                <ADGMImage name='Company_avatar.svg' alt='company' className={classes.headerLogo} aria-hidden='true' />
              </Box>
            )}
            <Box className={classes.headerContentV2}>
              <Typography variant='h6' component='h1' className={classes.TitleV2}>
                {keyEmptyCheck(applicationType)}
              </Typography>
              <Typography variant='body1' className={classes.subTitle}>
                {keyEmptyCheck('Application_ID')}: {applicationNumber}
              </Typography>
            </Box>
          </Grid>
        )}
        <Grid item xs={12} md={6} align='right' className={classes.rejectAcceptBtnHolder}>
          <Box display='flex' flexDirection='column' alignItems='end'>
            <Box display='flex' justifyContent='end'>
              {showSecondaryButton && (
                <Button
                  variant='outlined'
                  className={classNames(
                    classes.btns,
                    SecondaryBtnLabel === 'return_reject' ? classes.rejectBtnMenu : classes.rejectBtn,
                  )}
                  size='large'
                  onClick={e => {
                    if (applicationType === 'RENT_FEE_COLLECTION') return submitApplicationReject();
                    if (
                      applicationType === 'escrow_account_agreement_registration' &&
                      ['CHECKER_RETURN', 'MAKER_RETURN', 'RETURNED', 'DEVELOPER_RETURN'].includes(state?.type)
                    )
                      return submitApplicationReject();
                    if (
                      (applicationType === 'PMA_REGISTRATION' ||
                        applicationType === 'PMA_RENEWAL' ||
                        applicationType === 'PMA_CANCELLATION' ||
                        applicationType === 'PMA_AMENDMENT') &&
                      ['BANK_RETURN', 'PMC_SIGNATORY_RETURN', 'RETURNED', 'OWNER_RETURN', 'PMA_RETURN'].includes(
                        state?.type,
                      )
                    ) {
                      return submitApplicationReject();
                    }
                    return setDownloadMenuOpen(e.currentTarget);
                  }}
                  aria-controls='download-menu'
                  aria-haspopup='true'
                  endIcon={
                    SecondaryBtnLabel === 'return_reject' && (
                      <ADGMImage
                        name={isDownloadMenuOpen ? 'arrow-up-black.svg' : 'arrow-down-black.svg'}
                        alt='return'
                      />
                    )
                  }
                >
                  {/* {showSecondaryBtnIcon && <ADGMImage name='returnArrow.svg' alt='returnArrow' />} */}
                  {keyEmptyCheck(SecondaryBtnLabel)}
                </Button>
              )}
              <Menu
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                id='download-menu'
                anchorEl={isDownloadMenuOpen}
                open={Boolean(isDownloadMenuOpen)}
                onClose={() => setDownloadMenuOpen(null)}
                getContentAnchorEl={null}
                classes={{ paper: classes.navMenuDropdown, list: classes.menuList }}
              >
                <MenuItem
                  onClick={() => {
                    toggleModalReject();
                    handleClose();
                  }}
                >
                  {keyEmptyCheck('return_with_feedback')}
                </MenuItem>
                {showRejectApplicationBtn && (
                  <MenuItem onClick={rejectWithFeedback ? toggleModalRejectWithFeedback : toggleModalApplicationReject}>
                    {keyEmptyCheck('reject_with_feedback')}
                  </MenuItem>
                )}
              </Menu>
              {showPrimaryButton && (
                <Button
                  variant='contained'
                  className={classNames(classes.btns, classes.accptBtn)}
                  size='large'
                  onClick={submitHandler}
                >
                  <FormattedMessage {...messages[primaryBtnLabel]} />
                </Button>
              )}
            </Box>
            {typeof handleCancelApplication === 'function' && (
              <Button
                variant='text'
                className={classNames(classes.btns, classes.rejectApplicationbtn)}
                onClick={toggleModalCancellation}
              >
                <ADGMImage name='closeRed.svg' alt='rejectArrow' />
                <FormattedMessage {...messages.cancel_application} />
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
      <ADGMModal open={isModalOpenAcceptCancel} toggleModal={toggleModalAcceptCancel}>
        <div className={classNames(classes.innerModalAccept, classes.contractCancellationModal)}>
          <ADGMImage
            name='cross.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            aria-hidden='true'
            onClick={toggleModalAcceptCancel}
          />
          <Grid container alignContent='center'>
            <Grid item xs={12} md={12}>
              <div className={classes.imgHolder}>
                <ADGMImage name='Error.svg' alt='succes sent' className={classes.Successimg} />
              </div>
              <Typography variant='h5' component='h2' className={classes.Title}>
                <FormattedMessage {...messages.contract_cancellation_tenant_title} />
              </Typography>
              <p>
                <FormattedMessage {...messages.contract_cancellation_tenant_text} />
              </p>
              <Button variant='contained' className={classes.gotoHomeBtn} onClick={submitHandler}>
                <FormattedMessage {...messages.submit} />
              </Button>
            </Grid>
          </Grid>
        </div>
      </ADGMModal>
      <ADGMModal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpenCancellation}
        toggleModal={toggleModalCancellation}
        onClose={toggleModalCancellation}
      >
        <div className={classes.innerModalAccept}>
          <ADGMImage
            name='cross.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            aria-hidden='true'
            onClick={toggleModalCancellation}
          />
          <Typography variant='h6' component='h1' className={classes.Title}>
            <FormattedMessage {...messages.termination_title} />
          </Typography>
          <Typography variant='h6' component='h2' className={classes.subTitle}>
            <FormattedMessage {...messages.cancel_application_content} />
          </Typography>
          <div className={classes.modalBtnholder}>
            <Button
              variant='outlined'
              className={classNames(classes.btns, classes.TerminateBtn)}
              size='large'
              onClick={toggleModalCancellation}
            >
              <FormattedMessage {...messages.discard} />
            </Button>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.modalAccptBtn)}
              size='large'
              onClick={handleCancelApplication}
            >
              <FormattedMessage {...messages.cancel_application} />
            </Button>
          </div>
        </div>
      </ADGMModal>

      <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isRejectWithFeedBack}
        toggleModal={toggleModalRejectWithFeedback}
        onClose={toggleModalRejectWithFeedback}
      >
        <div className={classNames(classes.modal, classes.modalpaper)}>
          <ADGMImage
            name='cross-icon-black.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            onClick={toggleModalRejectWithFeedback}
            aria-hidden='true'
          />
          <div className={classes.modaltitlehead}>
            <ADGMImage
              name='BackClose.svg'
              alt='BackClose'
              className={classes.mobilebackarrow}
              onClick={toggleModalRejectWithFeedback}
              aria-hidden='true'
            />
          </div>
          <Typography variant='h6' component='h1' className={classes.tenantRejectTitle}>
            {keyEmptyCheck('reject_reason')} <span className={classes.required}> *</span>
          </Typography>
          <FormControl className={classes.formControl}>
            <div
              htmlFor='PropertyID'
              className={classNames([classes.unitinputControl, inputVal?.length === 500 && classes.colorRed])}
            >
              <TextareaAutosize
                aria-label='minimum height'
                minRows={1}
                placeholder={intl.formatMessage({ ...messages.reject_reason })}
                onChange={inputHandler}
                value={inputVal}
                maxLength={helperTextValue ? 500 : null}
              />
              {helperTextValue && (
                <Box display='flex' justifyContent='space-between'>
                  <Typography>{keyEmptyCheck(helperTextValue || 'rejection_feedback_text')}</Typography>
                  <Typography>{inputVal?.length ?? ''}/500</Typography>
                </Box>
              )}
            </div>
          </FormControl>
          <div className={classNames(classes.modalBtnholder, classes.feedbackmodalBtnholder)}>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.submitBtn)}
              size='large'
              onClick={submitRejectionWithfeedback}
              disabled={!inputVal}
            >
              {keyEmptyCheck('submit_reject_V2')}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpenReject}
        toggleModal={toggleModalReject}
        onClose={toggleModalReject}
      >
        <div className={classNames(classes.modal, classes.modalpaper)}>
          <ADGMImage
            name='cross-icon-black.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            onClick={toggleModalReject}
            aria-hidden='true'
          />
          <div className={classes.modaltitlehead}>
            <ADGMImage
              name='BackClose.svg'
              alt='BackClose'
              className={classes.mobilebackarrow}
              onClick={toggleModalReject}
              aria-hidden='true'
            />
          </div>
          <Typography variant='h6' component='h1' className={classes.tenantRejectTitle}>
            {keyEmptyCheck(rejectionTitle || 'return_reason')} <span className={classes.required}> *</span>
          </Typography>
          <FormControl className={classes.formControl}>
            <div htmlFor='PropertyID' className={classes.unitinputControl}>
              <TextareaAutosize
                aria-label='minimum height'
                minRows={1}
                placeholder={intl.formatMessage(
                  rejectionPlaceHolder ? { ...messages[rejectionPlaceHolder] } : { ...messages.return_reason },
                )}
                onChange={inputHandler}
                value={inputVal}
                maxLength={helperTextValue ? 500 : null}
              />
              <Box display='flex' justifyContent='space-between'>
                <Typography>{keyEmptyCheck(helperTextValue || 'rejection_feedback_text')}</Typography>
                <Typography>{inputVal?.length ?? ''}/500</Typography>
              </Box>
            </div>
          </FormControl>
          <div className={classNames(classes.modalBtnholder, classes.feedbackmodalBtnholder)}>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.submitBtn)}
              size='large'
              onClick={submitRejection}
              disabled={!inputVal}
            >
              {keyEmptyCheck('submit_return')}
            </Button>
          </div>
        </div>
      </Modal>

      <ADGMModal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpenApplicationReject}
        toggleModal={toggleModalApplicationReject}
        onClose={toggleModalApplicationReject}
      >
        <div className={classes.innerModalAccept}>
          <ADGMImage
            name='cross-icon-black.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            aria-hidden='true'
            onClick={toggleModalApplicationReject}
          />
          <Typography variant='h6' component='h1' className={classes.Title}>
            <FormattedMessage {...messages.reject_application} />?
          </Typography>
          <Typography variant='h6' component='h2' className={classes.subTitle}>
            <FormattedMessage {...messages.this_will_terminate_the_application} />
          </Typography>
          <div className={classes.modalBtnholder}>
            <Button
              variant='outlined'
              className={classNames(classes.btns, classes.TerminateBtn)}
              size='large'
              onClick={submitApplicationReject}
            >
              <FormattedMessage {...messages.reject} />
            </Button>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.modalAccptBtn)}
              size='large'
              onClick={toggleModalApplicationReject}
            >
              <FormattedMessage {...messages.cancel} />
            </Button>
          </div>
        </div>
      </ADGMModal>
      <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpenReturnAndReject}
        toggleModal={returnAndRejectmodal}
        onClose={returnAndRejectmodal}
        className={classes.returnAndRejectmodal}
      >
        <div className={classes.innerModalAccept}>
          <List component='div' disablePadding className={classes.RRcollapseList}>
            <ListItem button className={classes.ListItem} onClick={toggleModalReject}>
              <ListItemIcon className={classes.ListItemIcon}>
                <ADGMImage name='returnArrow.svg' alt='returnArrow' />
              </ListItemIcon>
              <ListItemText primary={<FormattedMessage {...messages.return_with_feedback} />} />
            </ListItem>
            <ListItem
              button
              className={classNames(classes.ListItem, classes.rejectListItem)}
              onClick={toggleModalApplicationReject}
            >
              <ListItemIcon className={classes.ListItemIcon}>
                <ADGMImage name='closeRed.svg' alt='rejectArrow' />
              </ListItemIcon>
              <ListItemText primary={<FormattedMessage {...messages.reject_application} />} />
            </ListItem>
          </List>
        </div>
      </Modal>
    </>
  );
}

ApprovalHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  property: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  handleSubmit: PropTypes.object.isRequired,
  submitApplicationReject: PropTypes.func.isRequired,
  failure: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  primaryBtnLabel: PropTypes.string.isRequired,
  applicationType: PropTypes.string.isRequired,
  applicationNumber: PropTypes.string,
  SecondaryBtnLabel: PropTypes.string.isRequired,
  showRejectApplicationBtn: PropTypes.bool,
  // showSecondaryBtnIcon: PropTypes.bool,
  showSecondaryButton: PropTypes.bool,
  showRejectModal: PropTypes.bool,
  showApplicationHeader: PropTypes.bool,
  rejectionTitle: PropTypes.string,
  rejectWithFeedback: PropTypes.bool,
  handleRejectSubmit: PropTypes.func,
  rejectionPlaceHolder: PropTypes.bool,
  showPrimaryButton: PropTypes.bool,
  helperTextValue: PropTypes.string,
  handleCancelApplication: PropTypes.func,
};

ApprovalHeader.defaultProps = {
  showRejectApplicationBtn: false,
  handleCancelApplication: null,

  // showSecondaryBtnIcon: false,
  showRejectModal: false,
  showSecondaryButton: true,
  applicationNumber: '',
  showApplicationHeader: false,
  rejectionTitle: '',
  rejectWithFeedback: false,
  showPrimaryButton: true,
  rejectionPlaceHolder: '',
  helperTextValue: '',
  handleRejectSubmit: () => {},
};
export default withStyles(stylesHeader)(injectIntl(ApprovalHeader));
